import { BaseLayoutFactory } from "../base-layout/base-layout-factory";
import { InactivityLogoutTimer } from "../components/inactive-logout-time";
import { BaseInternalForm } from "./base-internal-form";
import { BaseInternalFormProvider } from "./context/base-internal-form-context";

export function BaseInternalFormFactory({ children, pageTitle }: { children: React.ReactNode, pageTitle: string }) {
    return (
        <BaseLayoutFactory>
            <BaseInternalFormProvider>
                <InactivityLogoutTimer>
                    <BaseInternalForm pagetTitle={pageTitle}>
                        {children}
                    </BaseInternalForm>
                </InactivityLogoutTimer>
            </BaseInternalFormProvider>
        </BaseLayoutFactory>
    );
}